export const resolveDocsRoute = (rulename: string): string => {
  return `https://github.com/lasselupe33/eslint-plugin-grouped-css-declarations/blob/main/src/rules/${rulename}/_docs.md`;
};
